module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("点评智能分析编辑")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("信息")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('em', {
    staticClass: "font"
  }, [_vm._v("产品：")]), _vm._v(_vm._s(_vm.detail.PRODUCTNAME) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            类别：" + _vm._s(_vm.detail.CATEGORYNAME) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            厂商简称：" + _vm._s(_vm.detail.FACTORYNAME) + "\n          ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            优点：" + _vm._s(_vm.detail.advantages) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            不足：" + _vm._s(_vm.detail.disadvantages) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            时间：" + _vm._s(_vm.detail.lastoperationtime) + "\n          ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            综合评分：" + _vm._s(_vm.detail.ztgsnum) + "\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            建议提醒：" + _vm._s(_vm.detail.aftersales) + "\n          ")])], 1)], 1)]), _vm._v(" "), _c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("功能分析")])]), _vm._v(" "), _c('h4', [_vm._v("优点中提到的功能")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.suporiority), function(tag) {
    return _c('el-tag', {
      key: tag.id,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.function_title) + "\n          ")])
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', [_c('el-select', {
    ref: "selectCh",
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属维度分类"
    },
    on: {
      "change": _vm.searchSelect
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }, _vm._l((_vm.listG), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": ((item.id) + "," + (item.title))
      }
    }, [_vm._v(_vm._s(item.title) + "\n            ")])
  }), 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("不足中提到的功能")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.suporiority2), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.function_title) + "\n          ")])
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属维度分类"
    },
    on: {
      "change": _vm.searchSelect2
    },
    model: {
      value: (_vm.inputValue2),
      callback: function($$v) {
        _vm.inputValue2 = $$v
      },
      expression: "inputValue2"
    }
  }, _vm._l((_vm.listG), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": ((item.id) + "," + (item.title))
      }
    }, [_vm._v(_vm._s(item.title) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addItem2()
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "margin": "40px 0 0 0"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("其他维度分析")])]), _vm._v(" "), _c('h4', [_vm._v("优点中提到的维度")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.suporiority3), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleClose3(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.dimension_title) + "\n          ")])
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属维度分类"
    },
    on: {
      "change": _vm.searchSelect3
    },
    model: {
      value: (_vm.inputValue3),
      callback: function($$v) {
        _vm.inputValue3 = $$v
      },
      expression: "inputValue3"
    }
  }, _vm._l((_vm.listAll), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": ((item.id) + "," + (item.title))
      }
    }, [_vm._v(_vm._s(item.title) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem3
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('h4', [_vm._v("不足中提到的维度")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, _vm._l((_vm.suporiority4), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.handleClose4(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.dimension_title) + "\n          ")])
  }), 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属维度分类"
    },
    on: {
      "change": _vm.searchSelect4
    },
    model: {
      value: (_vm.inputValue4),
      callback: function($$v) {
        _vm.inputValue4 = $$v
      },
      expression: "inputValue4"
    }
  }, _vm._l((_vm.listAll), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": ((item.id) + "," + (item.title))
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addItem4
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "20px",
      "width": "250px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addAll()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3bc8f204!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/posts/Smart.vue
// module id = 452
// module chunks = 11